import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { IMAGES } from "@/lib/images";

export default function ColorInMotion() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });

  const scale = useTransform(scrollYProgress, [0, 1], [1.3, 1]);
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  const textY = useTransform(scrollYProgress, [0.2, 0.8], [70, -70]);

  return (
    <section ref={ref} className="relative h-[340vh]" data-testid="color-in-motion-section">
      <div className="sticky top-0 flex h-screen items-center justify-center overflow-hidden">
        <motion.img
          src={IMAGES.marble}
          alt="Crimson paint marbling that moves as you scroll"
          style={{ scale, y }}
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-black/15" />

        <motion.div style={{ y: textY }} className="relative z-10 px-4 text-center">
          <h2 className="font-serif text-7xl uppercase leading-[0.95] tracking-tight text-white sm:text-9xl">
            <span className="block">Color In</span>
            <span className="text-outline-white block">Motion</span>
          </h2>
        </motion.div>

        <p className="absolute bottom-10 left-1/2 z-10 w-full -translate-x-1/2 px-4 text-center font-mono text-[10px] uppercase tracking-[0.35em] text-white/75">
          Keep scrolling — the paint moves with you
        </p>
      </div>
    </section>
  );
}
